export default __webpack_public_path__ + "static/char-thumb-05-f94c96978db194d3e3ada14a54e57da1.png";